import { Modal, Form, Input, Typography } from 'antd';
import { useEffect } from 'react';

const RejectReferralModal = ({ open, onClose, onSubmit, record, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
  }, [open, form]);

  const handleOk = () => {
    form.validateFields().then((values) => onSubmit(values.reason));
  };

  return (
    <Modal
      title="Reject Referral"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={loading}
      okText="Reject"
      okButtonProps={{ danger: true }}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 16 }}>
        Rejecting <strong>{record?.childName}</strong>&apos;s referral. The referring doctor will be
        notified by email with the reason below.
      </Typography.Paragraph>
      <Form form={form} layout="vertical">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[
            { required: true, message: 'Please provide a reason for rejection' },
            { min: 3, message: 'Reason must be at least 3 characters' },
          ]}
        >
          <Input.TextArea rows={4} maxLength={1000} showCount placeholder="Explain why this referral is being rejected" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectReferralModal;
